module.exports = __webpack_public_path__ + "img/AMBSlot_lobby_tab_pic1.bab6cc0c.png";